import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertCircle, Activity, Droplets } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-10 md:py-28 bg-sage-500 text-white relative overflow-hidden" data-id="element-136">
      {/* Subtle background pattern/texture could go here, using a simple radial gradient for now */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.1)_0%,transparent_100%)]" data-id="element-137"></div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-138">
        <FadeIn data-id="element-139">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-12 text-center" data-id="element-140">
            El problema no es lo que comes,
            <br data-id="element-141" />
            es cómo reacciona tu biología.
          </h2>
        </FadeIn>

        <div className="space-y-8 md:space-y-12" data-id="element-142">
          <FadeIn delay={0.1} data-id="element-143">
            <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-144">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-white/20 flex items-center justify-center" data-id="element-145">
                <AlertCircle className="w-6 h-6 text-white" data-id="element-146" />
              </div>
              <div data-id="element-147">
                <h3 className="text-xl font-bold mb-3 font-sans" data-id="element-148">
                  El estado de "Alerta Constante"
                </h3>
                <p className="text-sage-100 leading-relaxed text-lg" data-id="element-149">
                  La mayoría de las mujeres viven en un estado de alerta
                  constante. El estrés, la falta de sueño y los alimentos que la
                  industria nos vende como "saludables" mantienen tu cortisol
                  por las nubes.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-150">
            <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-151">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-white/20 flex items-center justify-center" data-id="element-152">
                <Activity className="w-6 h-6 text-white" data-id="element-153" />
              </div>
              <div data-id="element-154">
                <h3 className="text-xl font-bold mb-3 font-sans" data-id="element-155">
                  El Efecto Dominó
                </h3>
                <p className="text-sage-100 leading-relaxed text-lg" data-id="element-156">
                  Esto crea un efecto dominó: tu intestino se vuelve permeable,
                  tu metabolismo se ralentiza y tu cuerpo decide retener cada
                  gramo de agua para "protegerse" de un ataque que no cesa. Por
                  eso te sientes "inflada" como un globo al final del día.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-157">
            <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-158">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-white/20 flex items-center justify-center" data-id="element-159">
                <Droplets className="w-6 h-6 text-white" data-id="element-160" />
              </div>
              <div data-id="element-161">
                <h3 className="text-xl font-bold mb-3 font-sans" data-id="element-162">
                  La Verdadera Causa
                </h3>
                <p className="text-sage-100 leading-relaxed text-lg" data-id="element-163">
                  Si te despiertas cansada, tienes neblina mental y tu vientre
                  parece tener vida propia después de comer, el problema no es
                  falta de voluntad. Es una inflamación celular profunda.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}